import {
  IItem,
  IEmptyValidatable,
} from "../items";
import { AbstractEmptyAlert } from "./AbstractEmptyAlert";

export class GroupEmptyAlert extends AbstractEmptyAlert<IItem & IEmptyValidatable> {
  constructor(itemSetId: number, item: IItem & IEmptyValidatable) {
    super(itemSetId, item, !item.enableEmptyCheckConfirmation);
  }

  get kind(): string {
    return "グループ警告";
  }

  protected get itemName(): string {
    return this._detectedItem.alertGroupKey;
  }
}
